<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         :width="`${width}px`" :height="`${height}px`"
         viewBox="0 0 18 14">
        <g id="equal-housing" stroke="none" stroke-width="1" fill="#10284A" fill-rule="evenodd">
            <g transform="translate(-131.000000, -226.000000)" fill="#10284A">
                <g transform="translate(131.000000, 226.000000)">
                    <polygon points="5.35243799 10.2807205 12.2145754 10.2807205 12.2145754 8.61160598 5.35243799 8.61160598"></polygon>
                    <polygon points="5.35243799 7.30410013 12.2145754 7.30410013 12.2145754 5.63498565 5.35243799 5.63498565"></polygon>
                    <path d="M8.78348723,-1.97061922e-05 L2.91654206e-05,4.35307815 L2.91654206e-05,6.21107647 L0.860117419,5.78483154 L0.860117419,11.8663595 L0.860117419,13.5355725 L2.5069915,13.5355725 L15.0600802,13.5355725 L16.7070515,13.5355725 L16.7070515,11.8663595 L16.7070515,5.78483154 L17.5670425,6.21107647 L17.5670425,4.35307815 L8.78348723,-1.97061922e-05 Z M2.5069915,4.96889665 L8.78348723,1.85866834 L15.0600802,4.96879812 L15.0600802,11.8663595 L2.5069915,11.8663595 L2.5069915,4.96889665 Z"></path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    import SVGMixin from './svg.mixin'

    export default {
        name: "EqualHousingSvg",
        mixins: [SVGMixin],
        props: {
            width: {
                default: 18
            },
            height: {
                default: 14
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>